import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { CalendarOptions, EventInput } from '@fullcalendar/core';
import { ApiService } from '@services/api/api.service';
import { CalendarAPIService } from '@services/api/calendarAPI.service';
import { ProjectService } from '@services/api/project.service';
import { AuthService } from '@services/auth.service';
import { ToasterService } from '@services/util/toaster.service';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import rrulePlugin from '@fullcalendar/rrule';
import { RRule } from 'rrule';
import { ReduxService } from '@state-management/redux.service';
import { FullCalendarComponent } from '@fullcalendar/angular';
import moment from 'moment';
import { commonImages } from '@images/common-images';
import { Leads } from '@modules/leads-management/leads/leads';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { SharedService } from '@services/api/shared.service';
import { ActivityTrackerService } from '@services/user-activity/activity-tracker.service';
import { RemmiConfirmService } from '@common/remmi-confirm/remmi-confirm.service';

@Component({
  selector: 'app-edit-lead-appointment',
  templateUrl: './edit-lead-appointment.component.html',
  styleUrls: ['./edit-lead-appointment.component.scss'],
})
export class EditLeadAppointmentComponent {
  @Input() leadDetail: any = null;
  @ViewChild('fullcalendar') fullcalendar: FullCalendarComponent;
  common_images = commonImages;

  options_calendar: CalendarOptions;
  isShort: boolean = true;
  isLong: boolean = false;
  project_appointment_list: any[] = [];
  record_detail: any = null;
  lead_event: any[] = [];
  appointmentRows: number = 30;
  event_popup = false;
  event_popup_detail = null;
  originalAssigns: any[] = [];
  googleAuthUrl: any;
  emailConnected: boolean = false;
  showConnectBtns: boolean = false;
  calendarAccessUser = [];
  AuthUser: any = null;
  insert_event = {
    app_title: '',
    project: null,
    app_type: null,
    attendees: [],
    location: '',
    description: '',
    availablebusy: 'Busy',
    availability: 'private',
    startdate: null,
    enddate: null,
    starttime: null,
    endtime: null,
  };

  public activeCalendarUser = null;
  Editor = ClassicEditor;
  email_Editor = ClassicEditor;
  hours: any[] = Leads.hours;
  minutes: any[] = Leads.minutes;
  calendar_views = Leads.calendar_views;
  lead_cal_view_grid = 'timeGridWeek';
  duration = ['AM', 'PM'];
  selectedStartHour = null;
  selectedStartMinutes = null;
  selectedStartDuration = 'AM';
  selectedEndHour = null;
  selectedEndMinutes = null;
  selectedEndDuration = 'AM';
  projectList: any[] = [];
  project_branding: any = null;
  appointment_client: any[] = [];
  property_project: any = null;
  object_event: any;
  exist_lead: any[] = [];
  dis_connected: any[] = [];

  constructor(
    public api: ApiService,
    private toaster: ToasterService,
    private _CalendarAPIService: CalendarAPIService,
    private Auth: AuthService,
    private redux: ReduxService,
    public sharedService: SharedService,
    public _projectService: ProjectService,
    private activityTracker: ActivityTrackerService,
    private remmiConfirm: RemmiConfirmService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    let record = changes?.leadDetail?.currentValue;
    this.record_detail = record;
  }

  ngOnInit(): void {
    this.calendarOptions();
    this.getProjectTags();
    this.getAgents();
    this.getProjects();
    this.checkUserStatus();
    this.calendarAccessUsers();
    // Fetched directly (not only via the calendarAccessUsers() chain below) so a failure or
    // delay in the unrelated calendar-access-user/auth-user lookups can't leave the Appointment
    // tab showing "no record found" for a lead that does have appointments.
    this.getProjectAppointments(this.record_detail);
  }

  ngAfterViewInit(): void {
    this.fullcalendar?.getApi()?.render();
  }

  resetForm(isProjectId = null) {
    this.insert_event = {
      app_title: '',
      project: isProjectId,
      app_type: null,
      attendees: [],
      location: '',
      description: '',
      availablebusy: 'Busy',
      availability: 'private',
      startdate: new Date(),
      enddate: null,
      starttime: null,
      endtime: null,
    };

    this.selectedStartHour = null;
    this.selectedStartMinutes = null;
    this.selectedStartDuration = null;
    this.selectedEndHour = null;
    this.selectedEndMinutes = null;
    this.selectedEndDuration = null;
  }

  getProjects() {
    // Fetches project list to populate the dropdown when user selects 'project' category
    this.sharedService.getDropDownItems('projects').subscribe({
      next: response => {
        this.projectList = [];
        this.projectList = response?.data;
      },
    });
  }

  checkUserStatus() {
    this._CalendarAPIService.checkGoogleCalendarConnectedStatus().subscribe({
      next: response => {
        if (response.connected == true) {
          this.emailConnected = true;
        } else {
          this.emailConnected = false;
          this.googleAuthUrl = response.data + '&state=' + this.api.getUserId();
        }
      },
    });
  }

  calendarAccessUsers() {
    this._CalendarAPIService.getUserCalendarAccess().subscribe(res => {
      this.calendarAccessUser = [];

      this.Auth.getUser().subscribe(user => {
        let authUser = user['data'];

        this._projectService.getProjectBranding(this.record_detail.project).subscribe({
          next: response => {
            this.project_branding = response?.data?.primary_color ? response?.data?.primary_color : response?.data?.secondary_color;
            this.AuthUser = [
              {
                _id: authUser._id,
                full_name: authUser.full_name,
                color: authUser.color,
                email: authUser.email,
              },
              {
                _id: this.record_detail?._id,
                full_name: this.record_detail?.listing_project?.project,
                color: this.project_branding ? this.project_branding : '#229276',
                isProject: true,
              },
            ];

            if (res?.data?.length > 0) {
              res.data?.forEach(element => {
                if (element.users) {
                  this.calendarAccessUser.push(element.users);
                }
              });
              this.calendarAccessUser.push(...this.AuthUser);
              this.calendarAccessUser = Array.from(new Map(this.calendarAccessUser.map(item => [item._id, item])).values());
              this.calendarAccessUser = this.calendarAccessUser.sort((a, b) => (a?.full_name > b?.full_name ? 1 : -1));
            } else {
              this.calendarAccessUser = this.AuthUser;
            }
          },
        });

        this.activeCalendarUser = [this.record_detail?._id];
        this.resetForm(this.record_detail.project);
        this.addclient();
        console.log('authUser', authUser);
        console.log('this.calendarAccessUser', this.calendarAccessUser);
      });
    });
  }

  getAgents() {
    let url = '/users/byoffice?office=' + this.api.getOfficeId() + '&show=staff';
    this.redux.getSetProjectInfo(false, 'byOffice', url).subscribe({
      next: response => {
        const { status, data } = response;
        if (status) {
          this.originalAssigns = JSON.parse(JSON.stringify(data));
        } else {
          this.originalAssigns = [];
        }
      },
    });
  }

  gSuiteLogin() {
    var win = window.open(this.googleAuthUrl, 'windowname1', 'width=800, height=600');

    window.addEventListener(
      'message',
      event => {
        if (event.data === 'authenticated') {
          this.emailConnected = true;
          win.close();
        }
      },
      false
    );
  }

  // Stores appointment types retrieved from project tags
  appointment_type: any[] = [];
  getProjectTags() {
    this.redux.getTags(this.api.getOfficeId(), true, 'project').subscribe({
      next: response => {
        let allTags = [];
        allTags = [...response?.data];

        // Iterates through the tags to find 'appointment-type' data
        allTags?.forEach(x => {
          [...x.types]?.forEach(y => {
            if (y?.slug == 'appointment-type') {
              this.appointment_type = [...y?.data]; // Stores the appointment types
            }
          });
        });
      },
    });
  }

  calendarOptions() {
    this.options_calendar = {
      firstDay: 1,
      initialView: 'timeGridWeek',
      initialDate: new Date(),
      headerToolbar: {
        left: 'prev,next',
        center: 'title',
        right: '',
      },
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, rrulePlugin],
      now: new Date(),
      events: [],
      editable: false,
      selectable: false,
      selectMirror: false,
      nowIndicator: true,
      expandRows: true,
      slotDuration: '01:00:00',
      scrollTime: '08:00:00',
      dayHeaderFormat: { day: 'numeric', weekday: 'short', omitCommas: true },
      titleFormat: { year: 'numeric', month: 'long' },
      dayMaxEvents: true,
      eventClick: event => {
        console.log('eve_eve:', event);
        this.event_popup = true;
        this.event_popup_detail = event.event.extendedProps;
        console.log('eve_del:', this.event_popup_detail);
        let creator_name = '';
        let findCreator = this.originalAssigns.filter(item => item._id == this.event_popup_detail?.extendedProperties?.private?.user_id);
        if (findCreator && findCreator.length > 0) {
          this.event_popup_detail.creator.full_name = findCreator[0].full_name;
        } else {
          this.event_popup_detail.creator.full_name = creator_name;
        }
      },

      eventDidMount: info => {
        const element = info.el.closest('.fc-daygrid-day-events');
        if (element) {
          if (info.event.extendedProps.isAllDay) {
            element.classList.add('all-day-event');
          } else {
            info.view.type === 'dayGridMonth' ? element.classList.add('no-all-day-event') : element.classList.remove('no-all-day-event');
          }
        }
      },
      eventContent: (arg: any) => {
        const viewType = arg.view.type; // e.g., 'dayGridMonth', 'timeGridWeek', etc.
        if (viewType === 'dayGridMonth') {
          // --- Month View Styling ---
          const eventTime = arg.event.extendedProps.start_time || '';
          const titleText = `${eventTime} ${arg.event.title}`;

          const container = document.createElement('div');
          container.classList.add('custom-month-event');

          const dot = document.createElement('span');
          dot.classList.add('event-dot');
          dot.style.backgroundColor = arg.backgroundColor || this.project_branding || '#229276';

          const title = document.createElement('span');
          title.classList.add('event-title');
          title.innerText = titleText;
          container.appendChild(dot);
          container.appendChild(title);
          return { domNodes: [container] };
        }

        // --- Default rendering for week/day views ---
        const title = document.createElement('div');
        title.innerText = arg.event.title;
        title.classList.add('fc-event-title-truncate');

        const time = document.createElement('div');
        time.innerText = arg.event.extendedProps.time;
        time.classList.add('fc-event-time');

        const container = document.createElement('div');
        container.appendChild(title);
        container.appendChild(time);

        return { domNodes: [container] };
      },
      eventMouseEnter: info => {
        const tooltip = document.createElement('div');
        tooltip.innerHTML = info.event.title;
        tooltip.className = 'fc-tooltip'; // Custom class
        tooltip.style.position = 'absolute';
        tooltip.style.top = `${info.jsEvent.pageY + 10}px`;
        tooltip.style.left = `${info.jsEvent.pageX + 10}px`;
        tooltip.style.background = this.project_branding || '#229276';
        tooltip.style.color = '#fff';
        tooltip.style.padding = '5px 10px';
        tooltip.style.borderRadius = '4px';
        tooltip.style.zIndex = '1000';
        document.body.appendChild(tooltip);
        info.el.setAttribute('data-tooltip-id', tooltip.id);
      },
      eventMouseLeave: () => {
        const tooltip = document.querySelector('.fc-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      },

      moreLinkClick: () => {
        const parentPopup = document.querySelectorAll('.fc-popover');
        if (parentPopup.length > 0) {
          for (let i = 0; i < parentPopup.length; i++) {
            parentPopup[i].remove();
            const calendarApi = this.fullcalendar?.getApi();
            if (calendarApi) {
              calendarApi.refetchEvents();
            }
          }
        }

        setTimeout(() => {
          // Changes for more link popup show
          const popoverBody = document.querySelector('.fc-popover-body');

          if (popoverBody) {
            // Select all event titles inside the popover
            const eventNodes = popoverBody.querySelectorAll('.fc-daygrid-event');
            eventNodes.forEach(node => {
              const timeElement = node.querySelector('.fc-event-time');
              const titleElement = node.querySelector('.fc-event-title');
              // Clean time format
              if (timeElement) {
                let timeText = timeElement.textContent || '';
                if (timeText.match(/^\d+a$/)) {
                  timeText = timeText.replace(/a$/, 'am');
                } else if (timeText.match(/^\d+p$/)) {
                  timeText = timeText.replace(/p$/, 'pm');
                }
                timeElement.textContent = timeText;
              }
              // Remove unnecessary ID from the title
              if (titleElement) {
                let titleText = titleElement.textContent || '';
                titleText = titleText.replace(/\s\|\s\(\{[^\}]+\}\)/, ''); // Remove ID pattern
                titleElement.textContent = titleText;
              }
            });
          }

          // For closing the more link popup button
          const closeButton = document.querySelector('.fc-popover-close');
          if (closeButton) {
            closeButton.addEventListener('click', () => {
              const parentPopup = document.querySelector('.fc-popover');
              if (parentPopup) {
                parentPopup.remove(); // Remove parent popup
                const calendarApi = this.fullcalendar?.getApi();
                if (calendarApi) {
                  calendarApi.refetchEvents();
                }
              }
            });
          }
        }, 10); // Ensure DOM is updated
      },

      dayMaxEventRows: true, // for all non-TimeGrid views
      views: {
        timeGrid: {
          dayMaxEventRows: 1, // adjust to 6 only for timeGridWeek/timeGridDay
        },
      },
    };
  }

  getProjectAppointments(record) {
    this._CalendarAPIService.getProjectContactEventsById(record?.contactid, record?._id, record?.project).subscribe({
      next: response => {
        this.project_appointment_list = response.data;
        this.options_calendar.events = [];
        this.lead_event = [];
        response.data.forEach(itm => {
          const matching = this.appointment_type.find(y => y?.tag_name === itm?.app_type);
          if (matching) {
            itm['background_color'] = matching?.background_color;
          }
          this.lead_event.push({
            title: itm?.event?.summary,
            backgroundColor: itm['background_color'] || this.project_branding || '#229276',
            date: itm?.event?.start?.dateTime,
            time: `${this.formatTimeRange(itm?.event?.start?.dateTime, itm?.event?.end?.dateTime)}`,
            start_time: `${this.startTimeRange(itm?.event?.start?.dateTime)}`,
            start: itm?.event?.start?.dateTime,
            end: itm?.event?.end?.dateTime,
            extendedProps: { ...itm?.event, _id: itm?._id },
          });
        });
        this.options_calendar = { ...this.options_calendar, events: [...this.options_calendar.events, ...(this.lead_event || [])] };
        this.fullcalendar?.getApi()?.render();
        console.log('optional >>:', this.options_calendar);
      },
    });
  }

  getUserCalendarDetail() {
    let records = this.calendarAccessUser?.filter(user => this.activeCalendarUser?.includes(user?._id));
    console.log('record >>:', records);
    let user_id = this.activeCalendarUser?.length > 0 ? this.activeCalendarUser : [this.api.getUserId()];
    this._CalendarAPIService.getCalendarEventsByUserIds(user_id, 'Property').subscribe({
      next: response => {
        const { status, message, data } = response;
        if (status) {
          this.options_calendar.events = [];
          let tempEventList: EventInput[] = [];
          if (data?.events?.length > 0) {
            data?.events?.forEach(ele => {
              records.forEach(user => {
                if (ele.summary == user?.email) {
                  ele['color'] = user?.color;
                }
              });
              if (ele?.items?.length > 0) {
                ele.items.forEach(itm => {
                  let isAllDay = itm?.start?.date !== undefined; // Check if it's a public holiday (All-day event)
                  let eventObj: EventInput;
                  if (isAllDay) {
                    eventObj = {
                      title: itm?.summary,
                      time: '',
                      start: itm?.start?.date, // Only date, no time
                      end: itm?.end?.date, // Only date, no time
                      extendedProps: { ...itm, allDay: true, calendar_id: itm?.id },
                      backgroundColor: ele?.color || this.project_branding || '#229276',
                    };
                    tempEventList.push(eventObj);
                  } else {
                    let rule = itm?.recurrence?.length > 0 ? RRule.fromString(itm?.recurrence[0]) : {};
                    let dated = new Date(itm?.start?.dateTime);
                    let hours = dated.getHours();
                    let min = dated.getMinutes();
                    let second = dated.getSeconds();
                    let ruled = {
                      ...rule['options'],
                      dtstart: dated,
                      byhour: [hours],
                      byminute: [min],
                      bysecond: [second],
                    };
                    if (rule['options']?.freq !== undefined) {
                      tempEventList.push({
                        title: itm.summary,
                        date: itm?.start?.dateTime,
                        time: `${this.formatTimeRange(itm?.start?.dateTime, itm?.end?.dateTime)}`,
                        start_time: `${this.startTimeRange(itm?.start?.dateTime)}`,
                        start: itm?.start?.dateTime,
                        end: itm?.end?.dateTime,
                        rrule: ruled,
                        extendedProps: { ...itm, user_id: ele?.user_id },
                        allDay: false,
                        backgroundColor: ele?.color || this.project_branding || '#229276',
                      });
                    } else {
                      tempEventList.push({
                        title: itm.summary,
                        date: itm?.start?.dateTime,
                        time: `${this.formatTimeRange(itm?.start?.dateTime, itm?.end?.dateTime)}`,
                        start_time: `${this.startTimeRange(itm?.start?.dateTime)}`,
                        start: itm?.start?.dateTime,
                        end: itm?.end?.dateTime,
                        extendedProps: { ...itm, user_id: ele?.user_id },
                        allDay: false,
                        backgroundColor: ele?.color || this.project_branding || '#229276',
                      });
                    }
                  }
                });
              }
            });
          }
          if (records) {
            let isExist = records?.find(ele => ele?.isLead == true);
            let event_list = isExist ? [...this.lead_event, ...tempEventList] : tempEventList;
            this.options_calendar = {
              ...this.options_calendar,
              events: [...this.options_calendar.events, ...(event_list || [])],
            };
          } else {
            this.options_calendar = {
              ...this.options_calendar,
              events: [],
            };
          }

          console.log('this.options_calendar >>:', this.options_calendar);

          this.fullcalendar?.getApi()?.render();
        } else {
          this.toaster.Error(message);
        }
      },
    });
  }
  attendeeList: string[] = [];
  emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  onAddEmail(event: any) {
    const value = event.value.trim();

    if (!this.emailRegex.test(value)) {
      const index = this.attendeeList.indexOf(value);
      if (index > -1) {
        this.attendeeList.splice(index, 1);
      }
    }
  }
  insertEvent() {
    this.property_project = this.projectList.find(ele => ele?._id === this.insert_event.project);
    // Checks if the end time is after the start time before proceeding
    if (this.isEndTimeAfterStartTime(this.insert_event.starttime, this.insert_event.endtime)) {
      // Creates start and end date objects based on the selected date and time
      var startDate = new Date(this.insert_event.startdate);
      startDate.setHours(this.insert_event.starttime.getHours());
      startDate.setMinutes(this.insert_event.starttime.getMinutes());
      startDate.setSeconds(this.insert_event.starttime.getSeconds());

      var endDate = new Date(this.insert_event.startdate);
      endDate.setHours(this.insert_event?.endtime?.getHours());
      endDate.setMinutes(this.insert_event?.endtime?.getMinutes());
      endDate.setSeconds(this.insert_event?.endtime?.getSeconds());

      // Converts start time to ISO string and retrieves timezone information
      var timeString = new Date(startDate)?.toISOString();
      var timeZone = Intl.DateTimeFormat()?.resolvedOptions()?.timeZone;

      // Calculates the duration between start and end times
      var duration = this.dateDiffToString(startDate, endDate);
      var startDate = new Date(timeString);
      var msDuration = (Number(duration.split(':')[0]) * 60 * 60 + Number(duration.split(':')[1]) * 60 + Number(duration.split(':')[2])) * 1000;
      var endDate = new Date(startDate.getTime() + msDuration);

      // Formats the start and end dates as ISO strings
      var isoStartDate = new Date(startDate.getTime() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().split('.')[0];

      var isoEndDate = new Date(endDate.getTime() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().split('.')[0];

      let date = this.insert_event.startdate;
      if (!date) {
        this.toaster.Error('Invalid date time');
        return;
      }

      // Constructs the event object with details

      this.object_event = {
        summary: `${this.property_project?.Project_Name}: ${this.insert_event.app_title}`,
        description: this.insert_event.description,
        start: {
          dateTime: isoStartDate,
          timeZone: timeZone,
        },
        end: {
          dateTime: isoEndDate,
          timeZone: timeZone,
        },
        visibility: this.insert_event.availability != null ? this.insert_event.availability : 'private',
        availablebusy: this.insert_event.availablebusy,
        location: this.property_project?.property_address,
      };

      // Adds additional event properties
      let clientList = this.appointment_client?.length > 0 ? this.appointment_client?.map(ele => ({ email: ele.email })) : [];
      let guestList = this.attendeeList?.length > 0 ? this.attendeeList?.map(ele => ({ email: ele })) : [];
      this.object_event['attendees'] = [...clientList, ...guestList];
      this.object_event['attendeeEmailList'] = this.attendeeList?.length > 0 ? this.attendeeList : [];
      this.object_event['sendNotifications'] = true;

      // Sets event transparency based on availability status
      if (this.insert_event.availablebusy.toLowerCase() == 'free') {
        this.object_event['transparency'] = 'transparent';
      }
      this.appointment_client = this.appointment_client?.map(ele => {
        ele = { ...ele, project: this.property_project?._id, project_details: this.property_project?.Project_Name };
        return ele;
      });

      let payload = {
        emails: this.appointment_client?.map(item => item.email),
        is_project: true,
      };

      // Checks if the project lead already exists before proceeding
      this.api.post(`/project-leads-exist/${this.property_project?._id}`, payload).subscribe({
        next: response => {
          if (response?.data?.length > 0) {
            this.exist_lead = response?.data;
            this.remmiConfirm
              .ask({
                title: 'Create Another Appointment?',
                message: 'An appointment has already been registered for this contact. Do you want to create another appointment?',
                confirmLabel: 'Create Appointment',
                tone: 'warning',
              })
              .subscribe(isConfirmed => isConfirmed && this.createEvent(this.object_event));
          } else {
            this.exist_lead = [];
            this.createEvent(this.object_event);
          }
        },
      });
    } else {
      // Displays an error if the start time is missing
      this.toaster.Error('Please add a start time');
    }
  }

  createEvent(event) {
    let object_event = {
      app_title: this.insert_event.app_title,
      app_type: this.insert_event.app_type,
      office_id: this.api.getOfficeId(),
      created_by: this.api.getUserId(),
      edit: this.appointmentId ? this.appointmentId : null,
      client: this.appointment_client?.length > 0 ? this.appointment_client : [],
      event: event,
      object_reference: this.insert_event.project,
      object_type: 'Project',
      type: 'Open Home',
      isInspection: false,
      user_id: [this.api.getUserId()],
    };

    this.api.post('/calendar/insert-project-event', object_event).subscribe(() => {
      this.toaster.Success('Event added successfully');
      this.getProjectAppointments(this.record_detail);
      this.resetForm();
      this.appointmentId = null;
      this.appointment_client = [];
      this.attendeeList = [];

      setTimeout(() => {
        this.addclient();
      }, 1500);
    });
  }

  contactSelection(e, i) {
    let check_name = e?.name?.split(' ');
    let first_name = check_name?.length > 0 ? check_name[0] : '';
    let last_name = check_name?.length > 1 ? check_name[1] : '';

    ((this.appointment_client[i].first_name = first_name),
      (this.appointment_client[i].first_name = last_name),
      (this.appointment_client[i].full_name = e?.name),
      (this.appointment_client[i].email = e?.email));
    this.appointment_client[i].mobile_no = e?.mobile_no;
    this.appointment_client[i].contactid = e?._id;
  }

  setAppointment() {
    let ele = [this.leadDetail?.contactid];
    this.api
      .get(
        `/search-data?office_id=${this.api.getOfficeId()}&filter=${JSON.stringify(ele)}&Keywords=&module=contacts&type=&company_type=&page=1&limit=40&project_id=null&listing_id=null`
      )
      .subscribe({
        next: res => {
          if (res?.data) {
            this.contactSelection(res?.data[0], 0);
          }
        },
      });
  }

  addclient() {
    if (this.leadDetail?.contactid) {
      let ele = [this.leadDetail?.contactid];
      this.api
        .get(
          `/search-data?office_id=${this.api.getOfficeId()}&filter=${JSON.stringify(ele)}&Keywords=&module=contacts&type=&company_type=&page=1&limit=40&project_id=null&listing_id=null`
        )
        .subscribe({
          next: res => {
            if (res?.data) {
              this.appointment_client.push({
                first_name: '',
                last_name: '',
                full_name: '',
                mobile_no: '',
                email: '',
                send_link: false,
                attendee: false,
                like_dislike: null,
                lead_category: 'project',
                lead_status: 'New',
                lead_type: 'Buyer',
                office_id: this.api.getOfficeId(),
                contactid: null,
                ofi_id: null,
              });
              this.contactSelection(res?.data[0], 0);
            }
          },
        });
    } else {
      this.appointment_client.push({
        first_name: '',
        last_name: '',
        full_name: '',
        mobile_no: '',
        email: '',
        send_link: false,
        attendee: false,
        like_dislike: null,
        lead_category: 'project',
        lead_status: 'New',
        lead_type: 'Buyer',
        office_id: this.api.getOfficeId(),
        contactid: null,
        ofi_id: null,
      });
    }
  }

  removeClient(i) {
    this.appointment_client.splice(i, 1);
  }

  appointmentId: any = null;
  editTableEvent(event) {
    console.log('event >>:', event);
    this.appointmentId = event?._id;
    this.activityTracker.trackRecordOpen({ entity_type: 'appointment', entity_id: event?._id });
    let start_time = event?.event?.start?.dateTime ? new Date(event?.event?.start?.dateTime) : null;
    let end_time = event?.event?.end?.dateTime ? new Date(event?.event?.end?.dateTime) : null;
    let date = event?.event?.start?.dateTime ? new Date(event?.event?.start?.dateTime) : new Date(event?.event?.start?.date);

    this.selectedStartHour = start_time ? moment(start_time).format('h') : null;
    this.selectedStartMinutes = start_time ? moment(start_time).format('mm') : null;
    this.selectedStartDuration = start_time ? moment(start_time).format('A') : null;
    this.selectedEndHour = end_time ? moment(end_time).format('h') : null;
    this.selectedEndMinutes = end_time ? moment(end_time).format('mm') : null;
    this.selectedEndDuration = end_time ? moment(end_time).format('A') : null;

    this.insert_event = {
      app_title: event?.app_title || '',
      project: event?.projectid || null,
      app_type: event?.app_type || null,
      attendees: event?.event?.attendees,
      location: '',
      description: event?.event?.description,
      availablebusy: event?.event?.availablebusy,
      availability: event?.event?.visibility,
      startdate: date,
      enddate: date,
      starttime: start_time,
      endtime: end_time,
    };

    this.appointment_client = event?.clients || [];
    this.attendeeList = event?.event?.attendeeEmailList?.length > 0 ? event?.event?.attendeeEmailList : [];
  }

  editCalendarEvent(event_popup_detail) {
    let findAppt = this.project_appointment_list?.find(ele => ele?._id == event_popup_detail?._id);
    if (findAppt) {
      this.event_popup = false;
      this.editTableEvent(findAppt);
    }
  }

  startHourChange() {
    // Set default minutes to '00' if not selected
    if (this.selectedStartMinutes == null || this.selectedStartMinutes == '---') {
      this.selectedStartMinutes = '00';
    }

    // Set default hour to '9' if not selected
    if (this.selectedStartHour == null || this.selectedStartHour == '') {
      this.selectedStartHour = '9';
    }

    let startTime = moment().format();

    // Convert to 24-hour format based on AM/PM selection
    if (this.selectedStartDuration == 'PM' && this.selectedStartHour != '12') {
      startTime = moment()
        .hour(Number(this.selectedStartHour) + 12)
        .minute(this.selectedStartMinutes)
        .format();
    } else {
      if (this.selectedStartHour == '12' && this.selectedStartDuration == 'AM') {
        // Handle 12 AM edge case by converting it to 00 in 24-hour format
        startTime = moment()
          .hour(Number(this.selectedStartHour) + 12)
          .minute(this.selectedStartMinutes)
          .format();
      } else {
        // Regular AM/PM time formatting
        startTime = moment().hour(this.selectedStartHour).minute(this.selectedStartMinutes).format();
      }
    }

    // Set start time and calculate end time as 30 minutes later
    this.insert_event.starttime = new Date(startTime);
    this.insert_event.endtime = new Date(moment(this.insert_event.starttime).add(30, 'm').format());

    // Extract end time details for UI binding
    this.selectedEndHour = String(moment(this.insert_event.endtime).format('h'));
    this.selectedEndMinutes = String(moment(this.insert_event.endtime).format('mm'));
    this.selectedEndDuration = moment(this.insert_event.endtime).format('A');
  }
  // Handles change in the selected start minutes and updates time fields accordingly
  startMinuteChange() {
    // Only proceed if minutes are selected and not default placeholder
    if (this.selectedStartMinutes != null && this.selectedStartMinutes != '---') {
      let startTime = moment().format();

      // Set default hour to '9' if not selected
      if (this.selectedStartHour == null || this.selectedStartHour == '') {
        this.selectedStartHour = '9';
      }

      // Convert to 24-hour format based on AM/PM selection
      if (this.selectedStartDuration == 'PM' && this.selectedStartHour != '12') {
        startTime = moment()
          .hour(Number(this.selectedStartHour) + 12)
          .minute(this.selectedStartMinutes)
          .format();
      } else {
        if (this.selectedStartHour == '12' && this.selectedStartDuration == 'AM') {
          // Handle 12 AM edge case
          startTime = moment()
            .hour(Number(this.selectedStartHour) + 12)
            .minute(this.selectedStartMinutes)
            .format();
        } else {
          // Regular AM/PM time formatting
          startTime = moment().hour(this.selectedStartHour).minute(this.selectedStartMinutes).format();
        }
      }

      // Set start time and calculate end time as 30 minutes later
      this.insert_event.starttime = new Date(startTime);
      this.insert_event.endtime = new Date(moment(this.insert_event.starttime).add(30, 'm').format());

      // Update end time fields for UI
      this.selectedEndHour = String(moment(this.insert_event.endtime).format('h'));
      this.selectedEndMinutes = String(moment(this.insert_event.endtime).format('mm'));
      this.selectedEndDuration = moment(this.insert_event.endtime).format('A');
    }
  }
  // Handles change in the selected end hour and updates end time
  endHourChange() {
    // Default end minutes to '00' if not selected
    if (this.selectedEndMinutes == null || this.selectedEndMinutes == '---') {
      this.selectedEndMinutes = '00';
    }

    // Default end hour to '9' if not selected
    if (this.selectedEndHour == null || this.selectedEndHour == '') {
      this.selectedEndHour = '9';
    }

    let endTime = moment().format();

    // Convert to 24-hour format based on AM/PM
    if (this.selectedEndDuration == 'PM' && this.selectedEndHour != '12') {
      endTime = moment()
        .hour(Number(this.selectedEndHour) + 12)
        .minute(this.selectedEndMinutes)
        .format();
    } else {
      if (this.selectedEndHour == '12' && this.selectedEndDuration == 'AM') {
        // Handle 12 AM as 00 hour in 24-hour time
        endTime = moment()
          .hour(Number(this.selectedEndHour) + 12)
          .minute(this.selectedEndMinutes)
          .format();
      } else {
        // Regular AM/PM formatting
        endTime = moment().hour(this.selectedEndHour).minute(this.selectedEndMinutes).format();
      }
    }

    // Set end time and update UI bindings
    this.insert_event.endtime = new Date(endTime);
    this.selectedEndHour = String(moment(this.insert_event.endtime).format('h'));
    this.selectedEndMinutes = String(moment(this.insert_event.endtime).format('mm'));
    this.selectedEndDuration = moment(this.insert_event.endtime).format('A');
  }
  // Handles change in the selected end minutes and updates end time
  endMinuteChange() {
    // Proceed only if valid minutes are selected
    if (this.selectedEndMinutes != null && this.selectedEndMinutes != '---') {
      let endTime = moment().format();

      // Default hour to '9' if not selected
      if (this.selectedEndHour == null || this.selectedEndHour == '') {
        this.selectedEndHour = '9';
      }

      // Convert to 24-hour format based on AM/PM
      if (this.selectedEndDuration == 'PM' && this.selectedEndHour != '12') {
        endTime = moment()
          .hour(Number(this.selectedEndHour) + 12)
          .minute(this.selectedEndMinutes)
          .format();
      } else {
        if (this.selectedEndHour == '12' && this.selectedEndDuration == 'AM') {
          // Handle edge case for 12 AM
          endTime = moment()
            .hour(Number(this.selectedEndHour) + 12)
            .minute(this.selectedEndMinutes)
            .format();
        } else {
          // Regular formatting
          endTime = moment().hour(this.selectedEndHour).minute(this.selectedEndMinutes).format();
        }
      }

      // Set the end time
      this.insert_event.endtime = new Date(endTime);
    }
  }

  startTimeRange(startTime: string): string {
    const start = moment(startTime);
    const startFormat = start.minutes() > 0 ? 'h:mma' : 'ha';
    return `${start.format(startFormat)}`;
  }
  formatTimeRange(startTime: string, endTime: string): string {
    const start = moment(startTime);
    const end = moment(endTime);

    const startFormat = start.minutes() > 0 ? 'h:mm' : 'h';
    const endFormat = end.minutes() > 0 ? 'h:mma' : 'ha';

    return `${start.format(startFormat)} - ${end.format(endFormat)}`;
  }
  getTimeFormat(dateTime) {
    return moment(dateTime).format('hh:mm A');
  }
  // Function to place CKEditor toolbar above the editor
  emailEditor(editor) {
    editor.ui.getEditableElement().parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
  }

  isEndTimeAfterStartTime(startTime, endTime) {
    const start = new Date(startTime);
    const end = new Date(endTime);
    return end > start;
  }

  dateDiffToString(a, b) {
    var diff = Math.abs(a - b);
    var ms = diff % 1000;
    diff = (diff - ms) / 1000;
    var ss = diff % 60;
    diff = (diff - ss) / 60;
    var mm = diff % 60;
    diff = (diff - mm) / 60;
    var hh = diff % 24;
    var days = (diff - hh) / 24;
    return days * 24 + hh + ':' + mm + ':' + ss;
  }

  leadChangeViewGrid() {
    // Changes calendar view to the grid view selected by the user
    this.fullcalendar.getApi().changeView(this.lead_cal_view_grid);
  }

  clear(item, nameType) {
    /**
     * Clears the specified item from the relevant array based on the nameType.
     * Updates the form controls or class properties accordingly.
     * @param item The item to be removed.
     * @param nameType The type indicating which array to update.
     */
    let localArray = [];
    switch (nameType) {
      case 'calendar':
        // Filter out the item from the 'activeCalendarUser' array and update it.
        localArray = this.activeCalendarUser.filter(x => x !== item);
        this.activeCalendarUser = localArray;
        break;
      default:
        // No action needed for unsupported nameType.
        break;
    }
  }

  /**
   * Delete a calendar event.
   * @param event The event to delete.
   */

  deleteCalendarEvent(event) {
    let query = {
      user_id: this.api.getUserId(),
      itm: event,
      appt_id: event?._id,
    };
    this.remmiConfirm
      .delete({
        title: 'Delete Appointment?',
        message: 'This appointment will be removed from the calendar.',
        subject: event?.summary || event?.title,
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this._CalendarAPIService.removeProjectEventFromCalendarByUserId(query).subscribe({
            next: () => {
              this.toaster.Success('Event removed successfully');
              this.event_popup = false;
              this.getProjectAppointments(this.record_detail);
              this.resetForm();
            },
            error: () => {
              this.toaster.Error('Something went wrong');
            },
          });
        }
      });
  }
}
